import styled from 'styled-components';

export const BlogMainContent = styled.section`
  line-height: 1.6em;
  margin-bottom: 30px;
`;

export const BlogHeader = styled.div`
  margin-bottom: 30px;
`;

export const BlogFooter = styled.div`
  margin-top: 60px;
`;
